import { ApiError } from '@/lib/api-client';

/** NestJS's default 403 text: it names no reason, so the user gets ours instead. */
const BARE_FORBIDDEN = new Set(['Forbidden resource', 'Forbidden']);

/**
 * The text to show for a failed request. A 400 "Validation failed" names no
 * field, so the server's per-field messages (`ApiError.details`) are shown
 * instead; a bare 403 becomes a sentence the user can act on.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    if (err.details?.length && err.message === 'Validation failed') {
      return err.details.map((d) => d.message).join('; ');
    }
    if (err.statusCode === 403 && BARE_FORBIDDEN.has(err.message)) {
      return 'You do not have permission to do this. Ask the business owner for access.';
    }
  }
  return (err instanceof Error && err.message) || fallback;
}

/** The server's message for one field of a refused request, if it named that field. */
export function apiErrorField(err: unknown, field: string): string | undefined {
  return err instanceof ApiError ? err.details?.find((d) => d.field === field)?.message : undefined;
}
